import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles/index';
import { withRouter } from 'react-router-dom';
import { FuseNavigation } from '@fuse';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const styles = theme => ({
    root: {}

});




class MainNavbar extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const { classes } = this.props;

        console.log('navigations', this.props.navigation);
        return (
            <div>
                <div className={classes.root} >
                    <FuseNavigation navigation={this.props.navigation} />
                </div>
            </div>

        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}

function mapStateToProps({ fuse }) {
    return {
        navigation: fuse.navigation
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(MainNavbar)));



// WEBPACK FOOTER //
// ./src/main/MainNavbarContent.js